import { Geolocation } from ".."

export interface CreateLocation {
    isDraft: boolean
    isActive: boolean
    names: {
        [key: string]: string
    }
    geolocation: Geolocation
}

export class CreateLocationFactory {
    static create(): CreateLocation {
        return {
            isDraft: false,
            isActive: false,
            names: {
                hr: "",
                en: "",
            },
            geolocation: {
                latitude: null,
                longitude: null,
            },
        }
    }
}
